import React from 'react';

export const UploadCategoryStateContext = React.createContext({});
